import script from "./Distribucion.vue?vue&type=script&setup=true&lang=js"
export * from "./Distribucion.vue?vue&type=script&setup=true&lang=js"

import "./Distribucion.vue?vue&type=style&index=0&id=e953f326&lang=css"

const __exports__ = script;

export default __exports__